import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { Divider, Grid, Paper, Button, ListItem } from "@material-ui/core";
import Axios from "axios";

import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";

import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import { useStyles } from "./DetailBook.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";

class DetailAuthor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookId: this.props.match.params.bookId,
      bookData: [],
      viewBook: false,
      pdfFile: "",
    };
  }

  async componentDidMount() {
    const response = await Axios.get(`${url}/api/books/${this.state.bookId}`);
    this.setState({
      bookData: response.data,
    });
  }

  handleApprove = async () => {
    let changedData = new FormData();
    changedData.append("bookCover", this.state.bookData.bookCoverUrl);
    changedData.append("bookFile", this.state.bookData.bookFileUrl);
    changedData.append("title", this.state.bookData.title);
    changedData.append("authorId", this.state.bookData.author._id);
    changedData.append("genre", this.state.bookData.genre);
    changedData.append("publishedDate", this.state.bookData.publishedDate);
    changedData.append("pageCount", this.state.bookData.pageCount);
    changedData.append("price", this.state.bookData.price);
    changedData.append("description", this.state.bookData.description);
    changedData.append("bookVerified", true);
    const response = await Axios.put(
      `${url}/api/books/${this.state.bookId}`,
      changedData,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.success) {
      this.props.history.push("/_administration_/books/unapproved");
    }
  };

  handleRead = (bookId) => {
    window.open(`/_administration_/book/read/${bookId}`, "_blank");
  };

  generateId = (length) => {
    let arr = new Uint8Array((length || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2Hex).join("");
  };

  dec2Hex = (dec) => {
    return dec < 10 ? "0" + String(dec) : dec.toString(16);
  };

  handleSendMessage = () => {
    this.props.history.push(
      `/_administration_/message/${this.state.bookData._id}`
    );
  };

  handleSendInvoice = () => {
    this.props.history.push(
      `/_administration_/invoice/bookpublish/${this.state.bookData._id}`
    );
    sessionStorage.setItem("invoiceId", this.generateId(16));
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <AdminPageTitle title="Book Details" />
          <Divider />
          {this.state.bookData.length !== 0 ? (
            <Grid container spacing={3} className={classes.gridContainer}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                xl={4}
                lg={4}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {console.log(this.state.bookData)}
                {this.state.bookData.bookCoverUrl === "undefined" ||
                !this.state.bookData.bookCoverUrl ? (
                  <div>
                    <div>Not Available</div>
                  </div>
                ) : (
                  <img
                    src={this.state.bookData.bookCoverUrl}
                    alt="Author"
                    style={{ width: 250, height: 250 }}
                  />
                )}
                <div>
                  {this.state.bookData.bookVerified === false && (
                    <div style={{ padding: 20 }}>
                      <Button
                        variant="outlined"
                        className={classes.buttonStyle}
                        onClick={this.handleApprove}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="outlined"
                        className={classes.buttonStyle}
                        onClick={this.handleSendMessage}
                      >
                        Send Message
                      </Button>
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
                <Paper style={{ padding: 10, fontSize: 16 }}>
                  <ListItem style={{ fontSize: 30, fontWeight: "bold" }}>
                    {this.state.bookData.title} (
                    {this.state.bookData.author.firstName}{" "}
                    {this.state.bookData.author.middleName}{" "}
                    {this.state.bookData.author.lastName})
                  </ListItem>
                  <div style={{ display: "flex" }}>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Published:</b>
                      {this.state.bookData.publishedDate}
                    </ListItem>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Genre:</b>
                      {this.state.bookData.genre}
                    </ListItem>
                  </div>
                  <div style={{ display: "flex" }}>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Price:</b> Rs.
                      {this.state.bookData.price}
                    </ListItem>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Total Page:</b>
                      {this.state.bookData.pageCount}
                    </ListItem>
                  </div>
                  <div style={{ display: "flex" }}>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Book Image:</b>
                      {this.state.bookData.bookCoverUrl === " " ||
                      this.state.bookData.bookCoverUrl === "undefined" ? (
                        <ClearIcon style={{ color: "red" }} />
                      ) : (
                        <CheckIcon style={{ color: "green" }} />
                      )}
                    </ListItem>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Book PDF:</b>
                      {this.state.bookData.bookFileUrl ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <CheckIcon style={{ color: "green" }} />
                          <div
                            className={classes.tooltip}
                            onClick={() =>
                              this.handleRead(this.state.bookData._id)
                            }
                          >
                            (Read Book)
                          </div>
                        </div>
                      ) : (
                        <ClearIcon style={{ color: "red" }} />
                      )}
                    </ListItem>
                  </div>
                  <ListItem
                    style={{
                      width: "100%",
                      padding: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 20,
                    }}
                  >
                    {this.state.bookData.description}
                  </ListItem>
                </Paper>
              </Grid>
            </Grid>
          ) : (
            <CustomLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(DetailAuthor)));
